import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Link } from "react-router-dom";
import { HelpCircle, Search, KeyRound, Languages, Star, Code2, Terminal } from "lucide-react";

const TOPICS = [
  { i: Search, t: "Comment rechercher ?", d: "Tapez votre requête ou pressez `/` n'importe où. Choisissez ensuite l'onglet Tout, Images, Vidéos ou News." },
  { i: KeyRound, t: "Pourquoi un compte ?", d: "Pour synchroniser favoris, historique et préférences sur tous vos appareils. Aucun tracker." },
  { i: Languages, t: "Traduction IA", d: "Menu trois points → Traduire. Propulsé par Claude Sonnet 4.5." },
  { i: Star, t: "Favoris", d: "Cliquez sur l'étoile dans le visualiseur de site pour ajouter à vos favoris." },
  { i: Code2, t: "API développeurs", d: "Créez une clé sur /developers et utilisez X-API-Key pour intégrer la recherche." },
  { i: Terminal, t: "Easter egg", d: "Pressez le Konami code sur l'accueil (↑↑↓↓←→←→BA). On ne vous a rien dit." },
];

const SHORTCUTS = [
  ["/", "Focus la barre de recherche"],
  ["Esc", "Fermer le visualiseur de site"],
  ["↑ / ↓", "Naviguer dans l'historique du terminal Hack"],
  ["Ctrl + clic", "Ouvrir un résultat dans un nouvel onglet"],
];

export default function HelpPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-12" data-testid="help-page">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight flex items-center gap-3 mb-2">
          <HelpCircle size={28} /> Aide
        </h1>
        <p className="text-sm text-gray-500 mb-10">Tout ce que vous devez savoir pour devenir un power-user d'OmniSearch.</p>

        <h2 className="text-xl font-bold mb-4">Sujets fréquents</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {TOPICS.map(({ i: Icon, t, d }) => (
            <div key={t} className="p-5 rounded-lg border border-[var(--omni-border)]">
              <Icon className="text-[var(--omni-accent)] mb-2" size={20} />
              <h3 className="font-bold mb-1">{t}</h3>
              <p className="text-sm text-gray-600">{d}</p>
            </div>
          ))}
        </div>

        <h2 className="text-xl font-bold mb-4">Raccourcis clavier</h2>
        <div className="border border-[var(--omni-border)] rounded-lg overflow-hidden">
          {SHORTCUTS.map(([k, d]) => (
            <div key={k} className="flex items-center justify-between px-4 py-3 border-b border-[var(--omni-border)] last:border-b-0">
              <span className="text-sm">{d}</span>
              <kbd className="font-mono text-xs px-2 py-1 rounded bg-[var(--omni-surface)] border border-[var(--omni-border)]">{k}</kbd>
            </div>
          ))}
        </div>

        <p className="text-sm text-gray-500 mt-10">
          Vous ne trouvez pas ? <Link to="/contact" className="text-[var(--omni-accent)] hover:underline font-medium">Contactez l'équipe</Link> — une IA répond aux questions simples en quelques secondes, sinon un humain vous écrit sous 24-48h.
        </p>
      </main>
      <Footer />
    </div>
  );
}
